/** `urgent` is rare by design (alarm fatigue); never shown by colour alone. */
export type CardSeverity = "calm" | "watch" | "urgent";

/** Unknown API values fall back to `calm` so they never paint phantom chrome. */
export const toCardSeverity = (value: string): CardSeverity =>
  value === "watch" || value === "urgent" ? value : "calm";
